import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from './ThemeProvider';
export function ThemeToggle() {
    const { theme, setTheme, actualTheme } = useTheme();
    return (_jsx(_Fragment, {})
    // <DropdownMenu>
    //   <DropdownMenuTrigger asChild>
    //     <Button 
    //       variant="ghost" 
    //       size="sm" 
    //       className="w-full justify-start gap-3 px-3 py-2.5 h-auto font-normal hover:bg-accent"
    //     >
    //       {actualTheme === 'dark' ? (
    //         <Moon className="w-4 h-4" />
    //       ) : (
    //         <Sun className="w-4 h-4" />
    //       )}
    //       <span className="text-sm">
    //         {theme === 'system' ? 'System' : theme === 'dark' ? 'Dark' : 'Light'} Theme
    //       </span>
    //     </Button>
    //   </DropdownMenuTrigger>
    //   <DropdownMenuContent align="start" className="w-40">
    //     <DropdownMenuItem 
    //      onClick={() => setTheme('light')}
    //       className="flex items-center gap-2 cursor-pointer"
    //     >
    //       <Sun className="w-4 h-4" />
    //       <span>Light</span>
    //       {theme === 'light' && <span className="ml-auto text-xs">✓</span>}
    //     </DropdownMenuItem>
    //     <DropdownMenuItem 
    //       onClick={() => setTheme('dark')}
    //       className="flex items-center gap-2 cursor-pointer"
    //     >
    //       <Moon className="w-4 h-4" />
    //       <span>Dark</span>
    //       {theme === 'dark' && <span className="ml-auto text-xs">✓</span>}
    //     </DropdownMenuItem>
    //     <DropdownMenuItem 
    //       onClick={() => setTheme('system')}
    //       className="flex items-center gap-2 cursor-pointer"
    //     >
    //       <Monitor className="w-4 h-4" />
    //       <span>System</span>
    //       {theme === 'system' && <span className="ml-auto text-xs">✓</span>}
    //     </DropdownMenuItem>
    //   </DropdownMenuContent>
    // </DropdownMenu>
    );
}
